import React from "react";

export default function TenantClaimsPanel({
  role,
  selectedProperty,
  tenantClaim,
  connectedClaims,
  canViewConnectedTenants,
  isSaving,
  onClaimResidency,
  onMoveOutResidency,
  onApproveResidency,
  onRejectResidency,
  onMarkTenantMovedOut,
  formatTime,
  styles,
}) {
  if (!selectedProperty?.id) return null;

  const tenantStatus = String(tenantClaim?.status || "").toLowerCase();
  const tenantHasOpenClaim = ["pending", "approved", "active"].includes(tenantStatus);

  return (
    <>
      {role === "tenant" ? (
        <div style={{ display: "grid", gap: 10, marginTop: 12 }}>
          {tenantHasOpenClaim ? (
            <>
              <span style={tenantStatus === "pending" ? styles.statusPillPending : styles.statusPillSuccess || styles.verifiedBadge}>
                {tenantStatus === "pending" ? "Residency Pending Review" : "Residency Approved"}
              </span>
              <button
                type="button"
                style={{ ...styles.secondaryButton, width: "100%", marginTop: 0 }}
                onClick={() => onMoveOutResidency(tenantClaim)}
                disabled={isSaving}
              >
                {isSaving ? "Updating..." : "I Moved Out"}
              </button>
            </>
          ) : tenantStatus === "rejected" ? (
            <>
              <span style={styles.statusPillDanger || styles.statusPillMuted}>Residency Rejected</span>
              <button
                type="button"
                style={{ ...styles.secondaryButton, width: "100%", marginTop: 0 }}
                onClick={onClaimResidency}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "I Live Here"}
              </button>
            </>
          ) : (
            <button
              type="button"
              style={{ ...styles.secondaryButton, width: "100%", marginTop: 0 }}
              onClick={onClaimResidency}
              disabled={isSaving}
            >
              {isSaving ? "Saving..." : "I Live Here"}
            </button>
          )}
          <p style={styles.smallText}>Residency claims are private and visible only to the approved landlord/manager or admin.</p>
        </div>
      ) : null}

      {canViewConnectedTenants ? (
        <div style={{ ...styles.propertyHistoryCard, marginTop: 12 }}>
          <strong style={styles.strongHeading}>Connected Tenants</strong>
          {connectedClaims.length ? (
            <div style={styles.propertyTimelineList}>
              {connectedClaims.map((claim) => (
                <div key={claim.id} style={styles.propertyTimelineItem}>
                  <span>{claim.tenantDisplayName || "Tenant"}</span>
                  <strong>
                    {claim.status || "pending"} · claimed {formatTime(claim.claimedAt) || "recently"}
                    {claim.movedOutAt ? ` · moved out ${formatTime(claim.movedOutAt) || ""}` : ""}
                  </strong>
                  {String(claim.status || "").toLowerCase() === "pending" ? (
                    <div style={styles.adminButtonGrid}>
                      <button type="button" style={styles.primaryButton} onClick={() => onApproveResidency(claim)} disabled={isSaving}>
                        Approve Tenant
                      </button>
                      <button type="button" style={styles.rejectButton} onClick={() => onRejectResidency(claim)} disabled={isSaving}>
                        Reject
                      </button>
                    </div>
                  ) : null}
                  {["approved", "active"].includes(String(claim.status || "").toLowerCase()) ? (
                    <button type="button" style={{ ...styles.secondaryButton, width: "100%", marginTop: 8 }} onClick={() => onMarkTenantMovedOut(claim)} disabled={isSaving}>
                      Mark Moved Out
                    </button>
                  ) : null}
                </div>
              ))}
            </div>
          ) : (
            <p style={styles.smallText}>No connected tenants yet.</p>
          )}
        </div>
      ) : null}
    </>
  );
}
